module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vresp7-5078b527bf5f3721b6b80a083a3e7026.jpg";